module.exports = __webpack_public_path__ + "img/slide14.c9241f5f.png";